import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse, IGetManyResponse } from '../../../utilities/http-utilities.service';
import {
  IKanbanColumn,
  IKanbanViewOption,
  TBulkCreateKanbanColumn,
  TBulkUpdateKanbanColumn,
} from './kanban-column.interface';

@Injectable({ providedIn: 'root' })
export class KanbanColumnService {
  private readonly endpoint = 'kanban-view-columns';

  constructor(private readonly http: HttpClient) {}

  public getViews(): Observable<IGetManyResponse<IKanbanViewOption>> {
    const params: HttpParams = new HttpParams()
      .set('fields', 'name,isDefault')
      .set('sort', 'name,ASC')
      .set('limit', '1000');

    return this.http.get<IGetManyResponse<IKanbanViewOption>>('kanban-views', { params });
  }

  public getColumns(kanbanViewId: number): Observable<IGetManyResponse<IKanbanColumn>> {
    const params: HttpParams = new HttpParams().set('kanbanViewId', kanbanViewId);

    return this.http.get<IGetManyResponse<IKanbanColumn>>(this.endpoint, { params });
  }

  public bulkCreate(kanbanViewId: number, payload: TBulkCreateKanbanColumn[]): Observable<IBaseResponse<void>> {
    return this.http.post<IBaseResponse<void>>(`${this.endpoint}/bulk/create`, { kanbanViewId, payload });
  }

  public bulkUpdate(kanbanViewId: number, payload: TBulkUpdateKanbanColumn[]): Observable<IBaseResponse<void>> {
    return this.http.patch<IBaseResponse<void>>(`${this.endpoint}/bulk/update`, { kanbanViewId, payload });
  }

  public bulkDelete(kanbanViewId: number, payload: number[]): Observable<IBaseResponse<void>> {
    return this.http.delete<IBaseResponse<void>>(`${this.endpoint}/bulk/delete`, { body: { kanbanViewId, payload } });
  }
}
